module.exports = __webpack_public_path__ + "img/float-btn-slot.97d27efc.svg";